<div class="modal-header">
    <h4 class="modal-title" style="font-weight:bold">Kopieer link naar rapport</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <a href="{{link}}" style="color:#666">{{ link }}</a>
    <br>
    <br>
    <span (click)="copyLink()" class="button cursor-pointer next-question-button"><span class="icon-copy"></span> Kopieer link</span>

</div>
